<template>
  <div class="question-panel" :class="{ closed: !opened }">
    <div class="panel-titlebar">
      <div class="question-icon">
        <img src="@/assets/images/question-icon.svg" alt="Icon">
      </div>

      <p :title="title">
        <strong>{{ title }}</strong>
      </p>

      <div class="panel-actions">
        <div class="close-panel" @click="$emit('remove')">
          <img src="@/assets/images/red-x.svg" alt="Remove panel" />
        </div>

        <img
            src="@/assets/images/hideshow-off.svg"
            alt="Hide panel"
            v-if="opened"
            @click="opened = !opened"
        />

        <img
            src="@/assets/images/hideshow-on.svg"
            alt="Show panel"
            v-else
            @click="opened = !opened"
        />
      </div>
    </div>

    <div>
      <div class="question-panel-title">
        <div class="title-pointer"></div>
        <p>{{ title }}</p>
      </div>

      <slot />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.question-panel {
  position: relative;
  width: 100%;
  height: auto;
  padding: 50px 30px 15px 30px;
  color: #404142;
  border-radius: 18px;
  margin-bottom: 15px;
  transition: height 250ms ease-in-out, padding 250ms ease-in-out;
  background-color: #F5F5F7;
  box-shadow: 0 2px 6px #ababab;
  z-index: 1;
  font-size: 13px;

  &.closed {
    overflow-y: hidden;
    padding-top: 0;
    padding-bottom: 0;
    height: 35px;
    border: none;

    .panel-titlebar {
      transform: none;
    }
  }

  p {
    margin: 0 0 10px;
    font-size: 13px;
  }

  .panel-titlebar {
    position: absolute;
    top: 0;
    left: 0;
    display: flex;
    align-items: center;
    width: 100%;
    height: 35px;
    padding: 8px 30px 8px 60px;
    font-size: 14px;
    font-family: MyriadProSemiBold, MyriadPro, Arial, Helvetica, sans-serif;
    border-radius: 10000px;
    box-shadow: 0 2px 6px #ababab;
    z-index: 999999;
    overflow: hidden;
    background-color: white;
    color: #404142;
    transform: translateY(-1px);

    .question-icon {
      position: absolute;
      left: 0;
      top: 0;
      height: 100%;
      width: 50px;
      color: white;
      background: transparent linear-gradient(95deg, #ed1979 0%, #cb03a4 100%);

      p, img {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      }

      img {
        height: 60%;
      }
    }

    > p {
      flex: 1;
      max-width: calc(100% - 25px);
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
      display: inline-block;
      margin: 0;
    }

    .panel-actions {
      display: flex;
      align-items: center;

      .close-panel {
        position: relative;
        width: 21px;
        height: 21px;
        background-color: white;
        border-radius: 100%;
        box-shadow: 0 2px 6px #ababab;
        margin-right: 15px;
        cursor: pointer;

        img {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
        }
      }

      > img {
        height: 10px;
        margin-right: -15px;
        cursor: pointer;
      }
    }
  }

  .question-panel-title {
    display: grid;
    grid-template-columns: auto 1fr;
    grid-template-areas: 'pointer question';
    -moz-column-gap: 10px;
    column-gap: 10px;
    margin-top: 15px;

    .title-pointer {
      grid-area: pointer;
      width: 0;
      height: 0;
      border-style: solid;
      border-width: 8px 0 8px 13px;
      border-color: transparent transparent transparent #ed1979;
    }

    p {
      grid-area: question;
      font-weight: bold;
    }
  }
}
</style>

<script>
export default {
  name: 'QuestionPanel',

  props: {
    title: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      opened: true,
    };
  },
};
</script>
